import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from "@angular/material/dialog";
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { UserOwnerRel } from '../model/userOwnerRel';
import { UserOwnerRelData } from '../model/userOwnerRelData';
import { AccessMethod } from '../model/accessMethod';
import { UserService } from '../service/user.service';
import { Log } from '../util/log';
import { PhoneNumberUtil, PhoneNumber, PhoneNumberFormat } from 'google-libphonenumber';
import { Subscription } from 'rxjs';
import { AccessMethods } from '../model/accessMethods';
import { RemoteHelper } from '../util/remoteHelper';

@Component({
  selector: 'app-user-import-dialog',
  templateUrl: './user-import-dialog.component.html',
  styleUrls: ['./user-import-dialog.component.css']
})
export class UserImportDialogComponent implements OnInit {

  @ViewChild('usersToImportTable', { static: true }) table;
  @ViewChild(MatSort) sort: MatSort;
  dataSource: MatTableDataSource<UserOwnerRelData>;

  phoneUtil = PhoneNumberUtil.getInstance();

  ownerUid: string;
  groupslist = new Map();
  usersToImport: UserOwnerRelData[] = [];
  usersUid: number[] = [];
  accessMethodsToImport: AccessMethods[] = [];
  methodCodes: string[] = [];


  existingUsersPhoneNumbers: string[] = [];
  inputUsersPhoneNumbers: string[] = [];

  errorString: string = "";


  groupNotFoundError: boolean = false;
  noGroupError: boolean = false;
  noNameError: boolean = false;
  methodDuplicateError: boolean = false;
  invalidPhoneNumberError: boolean = false;
  methodAlreadyExistsError: boolean = false;



  showGuidePage: boolean = true;
  showConfirmPage: boolean = false;
  showCreatingUsersPage: boolean = false;
  showErrorPage: boolean = false;
  showCreationSuccessfullPage: boolean = false;
  showUpdatingUsersPermissionsPage: boolean = false;

  createdUsersStr: string = $localize`:@@usersimportdialog_created_users:utenti creati su`
  updatedAccessMethodsStr: string = $localize`:@@usersimportdialog_access_methods_updated:metodi d'accesso caricati su`
  createdUsersStrComplete: string = "";
  updatingAccessMethodsComplete: string = "";

  userCount: number;
  currentUser: number;

  methodsCount: number;
  currentMethod: number;

  createUserSubscription: Subscription;
  updateUserSubscription: Subscription;
  updatedAcccessMethodsSubscription: Subscription;

  displayedColumns: string[] = [
    'name',
    'description',
    'groupName'
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<UserImportDialogComponent>,
    private userService: UserService
  ) {
    this.ownerUid = data.ownerUid;
    this.existingUsersPhoneNumbers = data.existingUsersPhoneNumbers;
  }

  ngOnInit(): void {

  }

  ngAfterViewInit() {
    this.getGroups();
  }

  ngOnDestroy(): void {

    if (this.createUserSubscription) {
      this.createUserSubscription.unsubscribe();
    }

    if (this.updateUserSubscription) {
      this.updateUserSubscription.unsubscribe();
    }


    if (this.updatedAcccessMethodsSubscription) {
      this.updatedAcccessMethodsSubscription.unsubscribe();
    }
  }



  changeListener(files: FileList) {

    this.groupNotFoundError = false;
    this.noNameError = false;
    this.noGroupError = false;
    this.methodDuplicateError = false;
    this.invalidPhoneNumberError = false;
    this.methodAlreadyExistsError = false;


    if (files && files.length > 0) {
      let file: File = files.item(0);
      //File reader method
      let reader: FileReader = new FileReader();
      reader.readAsText(file);
      reader.onload = (e) => {
        let csv: any = reader.result;

        let allTextLines = [];
        allTextLines = csv.split(/\r\n|\r|\n/g);

        let headers = allTextLines[0].split(';');
        let data = headers;
        let csvHeaders = [];
        for (let j = 0; j < headers.length; j++) {
          csvHeaders.push(data[j]);
        }

        let userData = [];

        for (let i = 1; i < allTextLines.length; i++) {

          Log.debug("\ni = ");
          Log.debug(i);

          if (!this.methodDuplicateError && !this.methodAlreadyExistsError) {

            userData = allTextLines[i].split(',');

            //riga vuota a fine file
            if (userData.length == 1) {
              break;
            }

            if (userData[0] == "User") {
              Log.debug("userData[0]");
              Log.debug(userData[0]);

              //creo l'oggetto AccessMethods per ogni utente
              this.accessMethodsToImport.push(new AccessMethods);
              this.accessMethodsToImport[this.accessMethodsToImport.length - 1].methods = [];

              let newUser = new UserOwnerRelData();

              if (!userData[1] || userData[1] == "") {
                this.noNameError = true;
              } else {
                newUser.name = userData[1];
                Log.debug("userData[1]");
                Log.debug(userData[1]);
              }

              if (!userData[2] || userData[2] == "") {
                newUser.description = "";
              } else {
                newUser.description = userData[2];
              }


              if (!userData[3] || userData[3] == "") {
                this.noGroupError = true;
              } else {
                newUser.groupName = userData[3];
                newUser.groupId = this.getGroupIdByName(userData[3]);
              }


              // if (!this.groupError && !this.prefixHasLettersError && !this.phoneNumberHasLettersError) {
              this.usersToImport.push(newUser);

            } else if (userData[0] == "Remote") {
              Log.debug("userData[0]");
              Log.debug(userData[0]);

              let method = new AccessMethod();

              method.code = userData[1];
              method.type = AccessMethod.EVENT_TYPE_REMOTE;

              //per il check sugli esistenti sarebbe necessario lo useruid ottenuto dopo la creazione, da sistemare
              // this.userService.isMethodUsedCheck(this.ownerUid, method).subscribe((data) => {
              //   if (data) {
              //     if (this.methodCodes.includes(method.code)) {
              //       Log.debug("duplicate method");
              //       this.methodDuplicateError = true;
              //       this.errorString = method.code;
              //     }
              //   } else {
              //     Log.debug("method exists");
              //     this.methodAlreadyExistsError = true;
              //     this.errorString = method.code;
              //   }
              // });


              if (this.methodCodes.includes(method.code)) {
                Log.debug("methodDuplicateError");
                this.methodDuplicateError = true;
                this.errorString = method.code;
                break;
              }
              this.methodCodes.push(method.code);


              this.accessMethodsToImport[this.accessMethodsToImport.length - 1].methods.push(method);
              // }
            } else if (userData[0] == "Phone") {
              Log.debug("userData[0]");
              Log.debug(userData[0]);

              let method = new AccessMethod();
              method.type = AccessMethod.EVENT_TYPE_PHONE;
              let numberToCheck = this.phoneUtil.parse("+" + userData[1] + userData[2]);

              if (this.phoneUtil.isValidNumber(numberToCheck)) {
                // this.items.controls[i].value.code = this.phoneUtil.format(numberToCheck, PhoneNumberFormat.E164);
                method.code = this.phoneUtil.format(numberToCheck, PhoneNumberFormat.E164);
              } else {

                Log.debug("invalidPhoneNumberError");

                this.invalidPhoneNumberError = true;
                this.errorString = "+" + userData[1] + userData[2];
                break;
              }

              //per il check sugli esistenti sarebbe necessario lo useruid ottenuto dopo la creazione, da sistemare
              // this.userService.isMethodUsedCheck(this.ownerUid, method).subscribe((data) => {
              //   if (data) {
              //     if (this.methodCodes.includes(method.code)) {
              //       Log.debug("duplicate method");
              //       this.methodDuplicateError = true;
              //       this.errorString = method.code;
              //     }
              //   } else {
              //     Log.debug("method exists");
              //     this.methodAlreadyExistsError = true;
              //     this.errorString = method.code;
              //   }
              // });


              if (this.methodCodes.includes(method.code)) {
                Log.debug("duplicate method");
                this.methodDuplicateError = true;
                this.errorString = method.code;
                break;
              }
              this.methodCodes.push(method.code);
              this.accessMethodsToImport[this.accessMethodsToImport.length - 1].methods.push(method);
              // }
            } else if (userData[0] == "Plate") {
              // console.log("userData[0]");
              // console.log(userData[0]);

              let method = new AccessMethod();
              method.type = AccessMethod.EVENT_TYPE_CAR;
              method.code = userData[1];

              if (this.methodCodes.includes(method.code)) {
                Log.debug("duplicate method");
                this.methodDuplicateError = true;
                this.errorString = method.code;
                break;
              }

              this.methodCodes.push(method.code);
              this.accessMethodsToImport[this.accessMethodsToImport.length - 1].methods.push(method);


            } else {
              break;
            }
          } else {
            break;
          }
        }

        if (!this.methodDuplicateError && !this.methodAlreadyExistsError && !this.invalidPhoneNumberError) {
          this.userCount = this.usersToImport.length;

          this.showGuidePage = false;

          this.showConfirmPage = true;
          setTimeout(() => {
            this.dataSource = new MatTableDataSource(this.usersToImport);
            this.table.dataSource = this.dataSource;
            this.table.dataSource.sort = this.sort;
          }, 300);
        }
      }
    }
  }

  confirmImport() {
    this.showConfirmPage = false;
    this.showCreatingUsersPage = true;
    this.uploadUsers(0);
  }

  uploadUsers(count: number) {
    this.currentUser = count;
    if (count < this.userCount) {

      this.createdUsersStrComplete = this.currentUser + " " + this.createdUsersStr + " " + this.userCount;

      let userOwnerRelDataToPut = this.usersToImport[count];

      let currentUserOwnerRelId;

      // Caricamento effettivo degli utenti
      this.createUserSubscription = this.userService.createUserOwnerRel(userOwnerRelDataToPut, this.ownerUid).subscribe((response) => {
        setTimeout(() => {

          currentUserOwnerRelId = response.id;

          this.updatedAcccessMethodsSubscription = this.userService.updateAccessMethods(this.accessMethodsToImport[count], currentUserOwnerRelId).subscribe((response) => {
            setTimeout(() => {

              let userOwnerRelToPut: UserOwnerRel = new UserOwnerRel();
              userOwnerRelToPut.name = userOwnerRelDataToPut.name;
              userOwnerRelToPut.description = userOwnerRelDataToPut.description;
              userOwnerRelToPut.groupId = userOwnerRelDataToPut.groupId;
              userOwnerRelToPut.id = currentUserOwnerRelId;

              this.updateUserSubscription = this.userService.updateUserOwnerRel(userOwnerRelToPut, currentUserOwnerRelId).subscribe((response) => {

                setTimeout(() => {
                  this.uploadUsers(this.currentUser + 1);

                }, 1000);
              }, (err) => {
                Log.debug(err);
              });
            }, 1000);
          }, (err) => {
            this.showCreatingUsersPage = false;
            this.showErrorPage = true;
          });

        }, 1000);
      }, (err) => {
        this.showCreatingUsersPage = false;
        this.showErrorPage = true;
      });

    } else {
      this.showCreatingUsersPage = false;
      this.showCreationSuccessfullPage = true;
    }
  }

  getGroups() {
    const obs = this.userService.getOwnerGroups(this.ownerUid);
    obs.subscribe(data => {
      for (let i = 0; i < data.length; i++) {
        this.groupslist.set(data[i].name, data[i].groupId);
      }

    });
  }

  getGroupIdByName(groupName): number {


    if (groupName == "0") {
      return 0;
    } else if (this.groupslist.has(groupName)) {

      return this.groupslist.get(groupName);
    } else {

      this.groupNotFoundError = true;
      this.errorString = groupName;
    }
  }

  checkIfMethodDuplicate(method: AccessMethod): boolean {

    //return finale altrimetni dà errore
    return true;
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
